module.exports = __webpack_public_path__ + "img/benefit_kroenke-vinyards.6c23aa81.jpg";